<div class="ot-required-label-wrapper" [ngClass]="{'ot-align-right': alignRight}">
  <label class="ot-field-label">
    <div class="ot-required-indicator">*</div> indicates required input
  </label>
</div>